import { NgModule } from '@angular/core';
import { NgbCollapse } from './collapse';

export { NgbCollapse } from './collapse';
export { NgbCollapseConfig } from './collapse-config';

@NgModule({ declarations: [NgbCollapse], exports: [NgbCollapse] })
export class NgbCollapseModule {}
